// extracted by mini-css-extract-plugin
module.exports = {"root":"DataViewHeader_root__1Q9T2","inner":"DataViewHeader_inner__3A8BQ"};